import React from "react";

import AuthService from "@common/services/Auth.service";
import dependencyInjection from "@common/util/dependencyInjection";

import AuthorizeView from "./views/AuthorizeView";

interface AuthServices {
  authService: AuthService;
}

const authService = AuthService.getInstance();

const [AuthDependencyProvider, useAuthDeps] = dependencyInjection<AuthServices>({
  services: { authService },
});

export const AuthorizePage = () => {
  return (
    <AuthDependencyProvider>
      <AuthorizeView />
    </AuthDependencyProvider>
  );
};

export { useAuthDeps };
